import request from '@/utils/request'

/* 上传文件 */
export function uploadFile(formData) {
  return request.post('/api/upload/upload', formData)
}

/* 登录 */
export function login(params = {}) {
  return request.post('/api/login/webLogin', {
    ...params
  })
}

/* 注册 */
export function register(params = {}) {
  return request.post('/api/login/saveUser', {
    registerType: 1,
    ...params
  })
}

/* 获取分类 */
export function fetchCategory(params = {}) {
  return request.get('/api/login/listUserCategory', {
    params
  })
}

/* 修改密码 */
export function changePassword(params = {}) {
  return request.post('/api/login/updateInfo', {
    ...params
  })
}

/* 获取邮箱验证码 */
export function getEmailCode(params = {}) {
  return request.get('/api/login/sendEmailCode', {
    params
  })
}

/* 验证邮箱验证码 */
export function verifyEmailCode(params = {}) {
  return request.post('/api/login/emailCodeInfo', {
    ...params
  })
}

/* 获取手机验证码 */
export function getPhoneCode(params = {}) {
  return request.get('/api/login/sendCode', {
    params
  })
}

/* 获取首页Banner */
export function fetchIndexBanner(params = {}) {
  return request.get('/api/web/banner', {
    params: {
      type: 0,
      ...params
    }
  })
}

/* 获取最新资讯Banner */
export function fetchNewsBanner(params = {}) {
  return request.get('/api/web/banner', {
    params: {
      type: 1,
      ...params
    }
  })
}

/* 获取模板下载列表 */
export function fetchTemplate(params = {}) {
  return request.get('/api/web/fileList', {
    params
  })
}

/* 模板下载量埋点接口 */
export function templateDownloadAmount(params = {}) {
  return request.get('/api/web/getFile', {
    params
  })
}

/* 搜索项目 */
export function fetchSearchResult(params = {}) {
  return request.get('/api/index/list', {
    params
  })
}

/* 获取招标公告 */
export function fetchNotice(params = {}) {
  return request.get('/api/index/list', {
    params: {
      status: 1,
      ...params
    }
  })
}

/* 获取中标公告 */
export function fetchWin(params = {}) {
  return request.get('/api/index/list', {
    params: {
      status: 5,
      ...params
    }
  })
}

/* 获取投标详情 */
export function fetchBidDetail(params = {}) {
  return request.get('/api/index/projectInfo', {
    params
  })
}

/* 收藏投标 */
export function collectBid(params = {}) {
  return request.get('/api/index/collectProject', {
    params: {
      action: 0,
      ...params
    }
  })
}

/* 取消收藏投标 */
export function cancelCollectBid(params = {}) {
  return request.get('/api/index/collectProject', {
    params: {
      action: 1,
      ...params
    }
  })
}

/* 接受邀约 */
export function acceptInvite(params = {}) {
  return request.get('/api/user/reject', {
    params: {
      type: 2,
      ...params
    }
  })
}

/* 拒绝邀约 */
export function refusedInvite(params = {}) {
  return request.get('/api/user/reject', {
    params: {
      type: 1,
      ...params
    }
  })
}

/* 上传标书 */
export function uploadBidFile(params = {}) {
  return request.post('/api/index/saveUserBid', {
    ...params
  })
}

/* 更新标书 */
export function updateBidFile(params = {}) {
  return request.post('/api/user/updateUrl', {
    ...params
  })
}

/* 获取招标预告 */
export function fetchPreview(params = {}) {
  return request.get('/api/index/newsList', {
    params: {
      type: 0,
      ...params
    }
  })
}

/* 获取预告详情 */
export function fetchPreviewDetail(params = {}) {
  return request.get('/api/index/newsInfo', {
    params: {
      type: 0,
      ...params
    }
  })
}

/* 收藏预告 */
export function collectPreview(params = {}) {
  return request.get('/api/index/collectNews', {
    params: {
      action: 0,
      ...params
    }
  })
}

/* 取消收藏预告 */
export function cancelCollectPreview(params = {}) {
  return request.get('/api/index/collectNews', {
    params: {
      action: 1,
      ...params
    }
  })
}

export function fetchCompanyIntroduction(params = {}) {
  return request.get('/api/web/pressInfo', {
    params
  })
}

/* 获取最新资讯 */
export function fetchNews(params = {}) {
  return request.get('/api/index/newsList', {
    params: {
      type: 1,
      ...params
    }
  })
}

/* 获取资讯详情 */
export function fetchNewsDetail(params = {}) {
  return request.get('/api/index/newsInfo', {
    params: {
      type: 1,
      ...params
    }
  })
}

/* 获取最新资讯的项目 */
export function fetchProject(params = {}) {
  return request.get('/api/index/newsList', {
    params: {
      type: 2,
      ...params
    }
  })
}

/* 获取资讯项目详情 */
export function fetchProjectDetail(params = {}) {
  return request.get('/api/index/newsInfo', {
    params: {
      type: 2,
      ...params
    }
  })
}

/* 获取用户信息 */
export function fetchUserInfo(params = {}) {
  return request.get('/api/user/webInfo', {
    params
  })
}

/* 更新个人信息 */
export function updateUserInfo(params = {}) {
  return request.post('/api/user/updateUserInfo', {
    ...params
  })
}

/* 获取我的收藏 */
export function fetchMyCollection(params = {}) {
  return request.get('/api/user/collect', {
    params
  })
}

/* 获取我的招标 */
export function fetchMyBids(params = {}) {
  return request.get('/api/user/projectParticipation', {
    params
  })
}

/* 获取我的邀约 */
export function fetchMyInvitation(params = {}) {
  return request.get('/api/user/invite', {
    params
  })
}

/* 获取我的消息 */
export function fetchUserMessage(params = {}) {
  return request.get('/api/user/getMessage', {
    params
  })
}

/* 获取消息详情 */
export function fetchUserMessageDetail(params = {}) {
  return request.get(`/api/user/getUserMessage/${params.id}`)
}

/* 检测是否有新的消息 */
export function checkNewMessage(params = {}) {
  return request.get('/api/user/isRead', {
    params
  })
}

/* 更新企业信息 */
export function updateCompanyInfo(params = {}) {
  return request.post('/api/user/update', {
    ...params
  })
}

/* 获取项目经验 */
export function fetchProjects(params = {}) {
  return request.get('/api/pastProjects/list', {
    params
  })
}

/* 新增项目经验 */
export function createProject(params = {}) {
  return request.post('/api/pastProjects/save', {
    ...params
  })
}

export function updateProject(params = {}) {
  return request.post('/api/pastProjects/update', {
    ...params
  })
}

export function deleteProject(params = {}) {
  return request.get('/api/pastProjects/delete', {
    params
  })
}
